import { createListSelector } from 'redux/utils'

export const selectShortCollectionData = createListSelector('ShortCollection')
